// Customizer const
export const TOGGLE_COLLAPSED_NAV = 'toggle_collapse_menu';
export const DRAWER_TYPE = 'drawer_type';
export const FIXED_DRAWER = 'fixed_drawer';
export const COLLAPSED_DRAWER = 'collapsible';
export const MINI_DRAWER = 'mini_drawer';
export const THEME_COLOR = 'theme_color';
export const DARK_THEME = 'dark_theme';
export const WINDOW_WIDTH = 'window-width';
export const SWITCH_LANGUAGE = 'switch-language';
export const CHANGE_DIRECTION = 'change-direction';

export const CHANGE_NAVIGATION_STYLE = 'change-navigation-style';
export const HORIZONTAL_NAVIGATION = 'horizontal_navigation';
export const VERTICAL_NAVIGATION = 'vertical_navigation';

export const HORIZONTAL_MENU_POSITION = 'horizontal_menu_position';
export const ABOVE_THE_HEADER = 'above_the_header';
export const INSIDE_THE_HEADER = 'inside_the_header';
export const BELOW_THE_HEADER = 'below_the_header';

//Contact Module const

export const SHOW_MESSAGE = 'show_message';
export const HIDE_MESSAGE = 'hide_message';

export const FETCH_ALL_CONTACT = 'fetch_all_contact';
export const FETCH_ALL_CONTACT_SUCCESS = 'fetch_all_contact_success';
export const ADD_FAVOURITE = 'add_favourite';
export const ON_CONTACT_SELECT = 'on_contact_select';
export const ON_ADD_CONTACT = 'on_add_contact';
export const ON_CONTACT_CLOSE = 'on_contact_close';
export const ON_FILTER_OPTION_SELECT = 'on_filter_option_select';
export const ON_SAVE_CONTACT = 'on_save_contact';
export const ON_DELETE_CONTACT = 'on_delete_contact';
export const ON_DELETE_SELECTED_CONTACT = 'on_delete_selected_contact';
export const FILTER_CONTACT = 'filter_contact';
export const GET_ALL_CONTACT = 'get_all_contact';
export const GET_UNSELECTED_ALL_CONTACT = 'get_unselected_all_contact';
export const ON_ALL_CONTACT_SELECT = 'on_all_contact_select';
export const UPDATE_SEARCH_USER = 'update_search_user';
export const ON_TOGGLE_DRAWER = 'on_toggle_drawer';
export const HANDLE_REQUEST_CLOSE = 'handle_request_close';
export const HIDE_CONTACT_LOADER = 'hide_contact_loader';

//Auth const
export const SIGNIN_USER = 'signin_user';
export const SIGNIN_USER_SUCCESS = 'signin_user_success';
export const SIGNIN_USER_ERROR = 'signin_user_error';
export const SIGNOUT_USER = 'signout_user';
export const SIGNOUT_USER_SUCCESS = 'signout_user_success';
export const INIT_URL = 'init_url';
export const RESTORE_PASSWORD_SUCCESS = 'restore_password_success';
export const RESTORE_PASSWORD_ERROR = 'restore_password_error';
export const RESET_RESTORE_PASSWORD_SUCCESS_FLAG = 'reset_restore_password_success_flag';
export const SERVER_LOGIN = 'server/login';
export const SERVER_LOGIN_WITH_TOKEN = 'server/login_with_token';
export const SERVER_LOG_OUT = 'server/log_out';
export const SERVER_RESTORE_PASSWORD = 'server/restore_password';
export const TOKEN_EXPIRED = 'token_expired';
export const CONNECTION_ERROR = 'connection_error';
export const CONNECTION_SUCCESS = 'connection_success';

// Chat Module const

export const FETCH_ALL_CHAT_USER = 'fetch_all_chat_user';
export const FETCH_ALL_CHAT_USER_CONVERSATION = 'fetch_all_chat_user_conversation';
export const FETCH_ALL_CHAT_USER_SUCCESS = 'fetch_all_chat_user_success';
export const FETCH_ALL_CHAT_USER_CONVERSATION_SUCCESS = 'fetch_all_chat_user_conversation_success';
export const FILTER_USERS = 'filter_users';
export const ON_SELECT_USER = 'on_select_user';
export const ON_SHOW_LOADER = 'on_show_loader';
export const ON_HIDE_LOADER = 'on_hide_loader';
export const USER_INFO_STATE = 'user_info_state';
export const SUBMIT_COMMENT = 'submit_comment';
export const UPDATE_MESSAGE_VALUE = 'update_message_value';
export const UPDATE_SEARCH_CHAT_USER = 'update_search_chat_user';

//// Mail Module const

export const ADD_LABEL = 'ADD_LABEL';
export const GET_ALL_MAIL = 'get_all_mail';
export const FETCH_ALL_MAIL = 'fetch_all_mail';
export const FETCH_ALL_MAIL_SUCCESS = 'fetch_all_mail_success';
export const GET_IMPORTANT_MAIL = 'get_important_mail';
export const GET_NAV_FILTERS = 'get_nav_filters';
export const GET_NAV_LABELS = 'get_nav_labels';
export const GET_NAV_FOLDER = 'get_nav_folder';
export const GET_READ_MAIL = 'get_read_mail';
export const GET_STARRED_MAIL = 'get_starred_mail';
export const GET_UNIMPORTANT_MAIL = 'get_unimportant_mail';
export const GET_UNREAD_MAIL = 'get_unread_mail';
export const GET_UNSELECTED_ALL_MAIL = 'get_unselected_all_mail';
export const GET_UNSTARRED_MAIL = 'get_unstarred_mail';
export const ON_ALL_MAIL_SELECT = 'on_all_mail_select';
export const ON_FOLDER_MENU_ITEM_SELECT = 'on_folder_menu_item_select';
export const ON_FOLDER_SELECT = 'on_folder_select';
export const ON_IMPORTANT_SELECT = 'on_important_select';
export const ON_LABEL_MENU_ITEM_SELECT = 'on_label_menu_item_select';
export const GET_MARK_AS_START = 'get_mark_as_start';
export const ON_LABEL_SELECT = 'on_label_select';
export const ON_MAIL_CHECKED = 'on_mail_checked';
export const ON_MAIL_SELECT = 'on_mail_select';
export const ON_MAIL_SEND = 'on_mail_send';
export const ON_OPTION_MENU_ITEM_SELECT = 'on_option_menu_item_select';
export const ON_OPTION_MENU_SELECT = 'on_option_menu_select';
export const ON_START_SELECT = 'on_start_select';
export const SEARCH_MAIL = 'search_mail';
export const ON_DELETE_MAIL = 'on_delete_mail';
export const SET_CURRENT_MAIL_NULL = 'set_current_mail_null';
export const ON_COMPOSE_MAIL = 'on_compose_mail';

//// TO-DO Module const

export const ON_SORTEND = 'on_sortend';
export const FETCH_ALL_TODO = 'fetch_all_todo';
export const FETCH_ALL_TODO_SUCCESS = 'fetch_all_todo-success';
export const FETCH_ALL_TODO_CONVERSATION = 'fetch_all_todo_conversation';
export const FETCH_ALL_TODO_CONVERSATION_SUCCESS = 'fetch_all_todo_conversation_success';
export const SELECT_ALL_TODO = 'select_all_todo';
export const GET_ALL_TODO = 'get_all_todo';
export const GET_UNSELECTED_ALL_TODO = 'get_unselected_all_todo';
export const GET_STARRED_TODO = 'get_starred_todo';
export const GET_UNSTARRED_TODO = 'get_unstarred_todo';
export const GET_IMPORTANT_TODO = 'get_important_todo';
export const GET_UNIMPORTANT_TODO = 'get_unimportant_todo';
export const ON_LABEL_UPDATE = 'on_label_update';
export const ON_TODO_UPDATE = 'on_todo_update';
export const ON_DELETE_TODO = 'on_delete_todo';
export const SEARCH_TODO = 'search_todo';
export const SHOW_TODOS = 'show_todos';
export const GET_TODO_CONVERSATION = 'get_todo_conversation';
export const ON_TODO_CHECKED = 'on_todo_checked';
export const ON_TODO_ADD = 'on_todo_add';
export const ON_TODO_SELECT = 'on_todo_select';
export const SET_CURRENT_TODO_NULL = 'set_current_todo_null';
export const REMOVE_LABEL = 'remove_label';
export const UPDATE_SEARCH = 'update_search';

// Profile const
// User
export const SET_MY_USER_PROFILE = 'set_my_user_profile';
export const SERVER_GET_CONTACTS = 'server/get_contacts';

export const SET_USER_PROFILE = 'set_user_profile';
export const SET_USER_GROUP_ROLE = 'set_user_group_role';
export const UPDATE_USER_DATA = 'update_user_data';
export const UPDATE_USER_REPLACEMENTS = 'update_user_replacements';
export const UPDATE_USER_NOTIFICATION_SETTINGS = 'update_user_notification_settings';
export const UPDATE_USER_ASSIGNMENT_OPTIONS = 'update_user_assignment_options';
export const UPDATE_USER_SETTINGS = 'update_user_settings';
export const UPDATE_USER_PASSWORD_SUCCESS = 'update_user_password_success';
export const UPDATE_USER_PASSWORD_ERROR = 'update_user_password_error';
export const RESET_MY_EXPIRED_PASSWORD_FLAG = 'reset_my_expired_password_flag';
export const UPDATE_USER_SETTINGS_SUCCESS = 'update_user_settings_success';

export const SERVER_GET_USER_PROFILE = 'server/get_user_profile';
export const SERVER_SET_USER_GROUP_ROLE = 'server/set_user_group_role';
export const SERVER_UPDATE_USER_DATA = 'server/update_user_data';
export const SERVER_UPDATE_USER_REPLACEMENTS = 'server/update_user_replacements';
export const SERVER_UPDATE_USER_NOTIFICATION_SETTINGS = 'server/update_user_notification_settings';
export const SERVER_UPDATE_USER_ASSIGNMENT_OPTIONS = 'server/update_user_assignment_options';
export const SERVER_UPDATE_USER_SETTING = 'server/update_user_settings';
export const SERVER_UPDATE_USER_PASSWORD = 'server/update_user_password';
export const SERVER_SET_USER_ACTIVE_STATUS = 'server/set_user_active_status';
export const REMOVE_ORGANISATION_USER = 'remove_organisation_user';
export const REMOVE_ORGANISATION_USER_SUCCESS = 'remove_organisation_user_success';
export const REMOVE_ORGANISATION_USER_ERROR = 'remove_organisation_user_error';
export const GET_USER_PROFILE_ERROR = 'get_user_profile_error';
export const SERVER_GENERATE_RECOVERY_KEY = 'server/generate_password_recovery_key';
export const GENERATE_RECOVERY_KEY_FEEDBACK = 'generate_recovery_key_feedback';
export const SERVER_SET_RECOVERY_PASSWORD = 'server/set_recovery_password';
export const SET_RECOVERY_PASSWORD_FEEDBACK = 'set_recovery_password_feedback';

// Group
export const SET_GROUP_PROFILE = 'set_group_profile';
export const ADD_USER_TO_GROUP = 'add_user_to_group';
export const REMOVE_USER_FROM_GROUP = 'remove_user_from_group';
export const UPDATE_GROUP_DATA = 'update_group_data';
export const UPDATE_GROUP_SETTINGS = 'update_group_settings';

export const UPDATE_GROUP_DATA_SUCCESS = 'update_group_data_success';
export const UPDATE_GROUP_DATA_ERROR = 'update_group_data_error';

export const SERVER_GET_GROUP_PROFILE = 'server/get_group_profile';
export const SERVER_ADD_USER_TO_GROUP = 'server/add_user_to_group';
export const SERVER_REMOVE_USER_FROM_GROUP = 'server/remove_user_from_group';
export const SERVER_UPDATE_GROUP_DATA = 'server/update_group_data';
export const SERVER_UPDATE_GROUP_SETTINGS = 'server/update_group_settings';
export const SERVER_TRIGGER_USER_GROUP_ADMIN_STATUS = 'server/trigger_user_group_admin_status';
export const GET_GROUP_PROFILE_ERROR = 'get_group_profile_error';

// Organisation
export const SET_ORGANISATION_PROFILE = 'set_organisation_profile';
export const UPDATE_ORGANISATION_DATA = 'update_organisation_data';
export const UPDATE_ORGANISATION_APP_USER_CONNECTIONS = 'update_organisation_app_user_connections';
export const UPDATE_ORGANISATION_CONTACTS = 'update_organisation_contacts';
export const SET_ORGANISATION_LIST_FILTER = 'set_organisation_list_filter';
export const SET_ORGANISATION_TABLE_PAGE = 'set_organisation_table_page';

export const SERVER_GET_ORGANISATION_PROFILE = 'server/get_organisation_profile';
export const SERVER_UPDATE_ORGANISATION_DATA = 'server/update_organisation_data';
export const SERVER_CREATE_NEW_GROUP = 'server/create_new_group';
export const SERVER_UPDATE_ORGANISATION_GROUP_STRUCTURE = 'server/update_organisation_group_structure';
export const SERVER_CREATE_NEW_USER = 'server/create_new_user';
export const SERVER_UPDATE_ORGANISATION_RESPONSIBILITIES = 'server/update_organisation_responsibilities';
export const SERVER_UPDATE_ORGANISATION_SETTINGS = 'server/update_organisation_settings';
export const SERVER_UPDATE_ORGANISATION_MELDOO_APP_SETTINGS = 'server/update_organisation_meldoo_app_settings';
export const SERVER_UPDATE_ORGANISATION_MELDOO_WEB_SETTINGS = 'server/update_organisation_meldoo_web_settings';
export const SERVER_ADD_ORGANISATION_APP_USER_CONNECTION = 'server/add_organisation_app_user_connection';
export const SERVER_REMOVE_ORGANISATION_APP_USER_CONNECTION = 'server/remove_organisation_app_user_connection';
export const SERVER_ADD_ORGANISATION_CONTACT = 'server/add_organisation_contact';
export const SERVER_UPDATE_ORGANISATION_CONTACT = 'server/update_organisation_contact';
export const SERVER_DELETE_ORGANISATION_CONTACT = 'server/delete_organisation_contact';
export const SERVER_UPDATE_ORGANISATION_SYSTEMROLES = 'server/update_organisation_systemroles';
export const ADD_ORGANISATION_USER = 'add_organisation_user';
export const ADD_ORGANISATION_GROUP = 'add_organisation_group';

export const SERVER_TRIGGER_CONNECTED_APP_USER_INTERNAL_TYPES = 'server/trigger_connected_app_user_internal_types';
export const SERVER_UPDATE_CONNECTED_APP_USER_INTERNAL_TYPES = 'server/update_connected_app_user_internal_types';

export const ADD_ORGANISATION_CONTACT_SUCCESS = 'add_organisation_contact_success';
export const ADD_ORGANISATION_CONTACT_ERROR = 'add_organisation_contact_error';
export const UPDATE_ORGANISATION_CONTACT_SUCCESS = 'update_organisation_contact_success';
export const UPDATE_ORGANISATION_CONTACT_ERROR = 'update_organisation_contact_error';
export const DELETE_ORGANISATION_CONTACT_SUCCESS = 'delete_organisation_contact_success';
export const DELETE_ORGANISATION_CONTACT_ERROR = 'delete_organisation_contact_error';
export const UPDATE_ORGANISATION_SYSTEMROLES_SUCCESS = 'update_organisation_systemroles_success';
export const UPDATE_ORGANISATION_SYSTEMROLES_ERROR = 'update_organisation_systemroles_error';
export const UPDATE_ORGANISATION_DATA_SUCCESS = 'update_organisation_data_success';
export const UPDATE_ORGANISATION_DATA_ERROR = 'update_organisation_data_error';
export const UPDATE_ORGANISATION_SETTINGS_SUCCESS = 'update_organisation_settings_success';
export const UPDATE_ORGANISATION_SETTINGS_ERROR = 'update_organisation_settings_error';
export const ADD_ORGANISATION_USER_SUCCESS = 'add_organisation_user_success';
export const ADD_ORGANISATION_USER_ERROR = 'add_organisation_user_error';
export const ADD_ORGANISATION_GROUP_SUCCESS = 'add_organisation_group_success';
export const ADD_ORGANISATION_GROUP_ERROR = 'add_organisation_group_error';

export const SERVER_GET_AFFILIATED_ORGANISATIONS = 'server/get_affiliated_organisations';
export const SET_AFFILIATED_ORGANISATIONS = 'set_affiliated_organisations';
export const GET_ORGANISATION_PROFILE_ERROR = 'get_organisation_profile_error';

export const UPDATE_ORGANISATION_GROUP_STRUCTURE = 'update_organisation_group_structure';

export const UPDATE_ORGANISATION_PROFILE_TYPES_UPDATE = 'update_organisation_profile_types_update';

export const SERVER_CREATE_TYPE = 'server/create_type';
export const SERVER_GET_TYPES = 'server/get_types';
export const RESET_CREATE_TYPE = 'reset_create_type';
// Citizen
export const SET_CITIZEN_PROFILE = 'set_citizen_profile';
export const UPDATE_CITIZEN_DATA = 'update_citizen_data';
export const SERVER_GET_CITIZEN_PROFILE = 'server/get_citizen_profile';
export const SERVER_UPDATE_CITIZEN_DATA = 'server/update_citizen_data';
export const SERVER_REPORT_CITIZEN = 'server/report_citizen';
export const REPORT_CITIZEN_SUCCESS = 'report_citizen_success';
export const REPORT_CITIZEN_ERROR = 'report_citizen_error';

// Statistics const

export const GET_ADMIN_DASHBOARD_STATISTICS = 'get_admin_dashboard_statistics';

export const SET_COST_UNIT_STATUS_STATISTICS_DATA = 'set_cost_unit_status_statistics_data';
export const SET_APP_USER_STATISTICS = 'set_app_user_statistics';
export const SET_REPORT_TYPE_STATISTICS = 'set_report_type_statistics';
export const SET_USER_STATISTICS = 'set_user_statistics';
export const SET_ADMIN_REPORT_STATISTICS = 'set_admin_report_statistics';
export const SET_ADMIN_REPORT_STATISTICS_TYPE_FILTER = 'set_admin_report_statistics_type_filter';
export const SET_ADMIN_REPORT_STATISTICS_DATE = 'set_admin_report_statistics_date';

export const SERVER_GET_USER_STATISTICS = 'server/get_user_statistics';
export const SERVER_GET_ADMIN_REPORT_STATISTICS = 'server/get_admin_report_statistics';
export const SERVER_GET_ADMIN_APPUSER_STATISTICS = 'server/get_admin_user_statistics';

export const SERVER_GET_ORGANISATION_STATISTICS = 'server/get_organisation_statistics';
export const SET_ORGANISATION_STATISTICS = 'set_organisation_statistics';
export const GET_ORGANISATION_STATISTICS_ERROR = 'get_organisation_statistics_error';

// Report const

export const GET_REPORTS = 'get_reports';
export const SET_REPORTS = 'set_reports';
export const GET_REPORT_DETAILS = 'get_report_details';
export const SET_REPORT_DETAILS = 'set_report_details';
export const SEND_NEW_CHAT_MESSAGE = 'send_new_chat_message';
export const SET_NEW_CHAT_MESSAGE = 'set_new_chat_message';
export const UPDATE_REPORT_ASSIGNMENT = 'update_report_assignment';
export const SET_UPDATED_REPORT_ASSIGNMENT = 'set_updated_report_assignment';
export const UPDATE_REPORT_PRIORITY = 'update_report_priority';
export const SET_REPORT_PRIORITY = 'set_report_priority';
export const COMPLETE_REPORT = 'complete_report';
export const DECLINE_REPORT = 'decline_report';
export const DELETE_REPORT = 'delete_report';
export const RESTORE_REPORT = 'restore_report';
export const UPDATE_REPORT_STATUS = 'update_report_status';
export const CITIZEN_COMPLETE_RESPONSE = 'citizen_complete_response';
export const SET_REPORT_VISIBILITY = 'set_report_visibility';
export const DISCONNECT_REPORTS = 'disconnect_reports';
export const CONNECT_REPORTS = 'connect_reports';
export const SET_REPORT_DEADLINE = 'set_report_deadline';
export const SET_REPORT_RESUBMISSION = 'set_report_resubmission';
export const ADD_REPORT_USERCOMMENT = 'add_report_usercomment';
export const STOP_OBSERVING_REPORT = 'stop_observing_report';
export const ASSIGN_REPORT = 'assign_report';
export const UPDATE_REPORTS = 'update_reports';
export const GENERATE_REPORT_PDF = 'generate_report_pdf';
export const SET_UNCONTROLLED_REPORTS = 'set_uncontrolled_reports';
export const SET_REPORTS_CONTROLLED = 'set_reports_controlled';
export const SET_PASS_REPORTS_SUMMARY = 'set_pass_reports_summary';
export const RELOAD_REPORT_EDIT_IMAGE = 'reload_report_edit_image';
export const UPDATE_REPORT_STATUS_ERROR = 'update_report_status_error';
export const DISCONNECT_REPORTS_ERROR = 'disconnect_reports_error';
export const UPDATE_REPORT_ORGANISATION = 'update_report_organisation';
export const UPDATE_REPORT_RESPONSIBLE = 'update_report_responsible';
export const UPDATE_REPORT_RESPONSIBLE_ERROR = 'update_report_responsible_error';
export const SET_NEW_CHAT_MESSAGE_ERROR = 'set_new_chat_message_error';
export const ADD_REPORT_USERCOMMENT_ERROR = 'add_report_usercomment_error';
export const SET_REPORT_DETAILS_ERROR = 'set_report_details_error';
export const REMOVE_CITIZEN_COMPLETE = 'remove_citizen_complete';
export const SET_REPORTS_FILTER = 'set_reports_filter';
export const SET_REPORTS_TABLE_PAGE = 'set_reports_table_page';
export const SET_REPORTS_TABLE_PAGE_SIZE = 'set_reports_table_page_size';
export const SET_REPORTS_TABLE_COLUMN_SIZE = 'set_report_table_column_size';
export const SET_REPORT_DETAILS_AUTH_ERROR = 'set_report_details_auth_error';
export const UPDATE_REPORT_OBSERVER = 'update_report_observer';
export const ADD_REPORT_LOG_ITEM = 'add_report_log_item';
export const GET_REPORT_DETAILS_ERROR = 'get_report_details_error';
export const DUPLICATE_REPORT_ERROR = 'duplicate_report_error';
export const DUPLICATE_REPORT = 'duplicate_report';
export const UPDATE_REPORT_USER_COMMENT = 'update_report_user_comment';
export const DELETE_REPORT_USER_COMMENT = 'delete_report_user_comment';
export const SET_REPORT_DETAILS_ORIGIN = 'set_report_details_origin';
export const UPDATE_REPORT_RECORDS = 'update_report_records';
export const SET_CONNECTED_REPORTS = 'set_connected_reports';
export const SET_ADDITIONAL_REPORT_DATA = 'set_additional_report_data';
export const SET_REPORT_CONNECTIONS = 'set_report_connections';

// Report Server const

export const SERVER_GET_REPORTS = 'server/get_reports';
export const SERVER_COMPLETE_REPORT = 'server/complete_report';
export const SERVER_DECLINE_REPORT = 'server/decline_report';
export const SERVER_DELETE_REPORT = 'server/delete_report';
export const SERVER_RESTORE_REPORT = 'server/restore_report';
export const SERVER_CITIZEN_COMPLETE_RESPONSE = 'server/citizen_complete_response';
export const SERVER_UPDATE_REPORT_PRIORITY = 'server/update_report_priority';
export const SERVER_UPDATE_REPORT_ASSIGNMENT = 'server/update_report_assignment';
export const SERVER_SEND_NEW_CHAT_MESSAGE = 'server/send_new_chat_message';
export const SERVER_UPDATE_REPORT_VISIBILITY = 'server/update_report_visibility';
export const SERVER_GET_REPORT_DETAILS = 'server/get_report_details';
export const SERVER_UPDATE_REPORT_DATA = 'server/update_report_data';
export const SERVER_SET_REPORT_DEADLINE = 'server/set_report_deadline';
export const SERVER_DISCONNECT_REPORTS = 'server/disconnect_reports';
export const SERVER_CONNECT_REPORTS = 'server/connect_reports';
export const SERVER_SET_REPORT_RESUBMISSION = 'server/set_report_resubmission';
export const SERVER_SEND_REPORT_USERCOMMENT = 'server/send_report_usercomment';
export const SERVER_REASSIGN_REPORT = 'server/reassign_report';
export const SERVER_STOP_OBSERVING_REPORT = 'server/stop_observing_report';
export const SERVER_ASSIGN_REPORT = 'server/assign_report';
export const SERVER_SET_REPORT_IN_PROCESS = 'server/set_report_in_process';
export const SERVER_REMOVE_REPORT_IN_PROCESS = 'server/remove_report_in_process';
export const SERVER_GET_UNCONTROLLED_REPORTS = 'server/get_uncontrolled_reports';
export const SERVER_UPDATE_REPORT_ORGANISATION = 'server/update_report_organisation';
export const SERVER_UPDATE_REPORT_RESPONSIBLE = 'server/update_report_responsible';
export const SERVER_PASS_REPORTS = 'server/pass_reports';
export const SERVER_EDIT_REPORT_IMAGE = 'server/edit_report_image';
export const SERVER_UPDATE_REPORT_OBSERVER = 'server/update_report_observer';
export const SERVER_DUPLICATE_REPORT = 'server/duplicate_report';
export const SERVER_UPDATE_CHAT_MESSAGE_STATUS = 'server/update_chat_message_status';
export const SERVER_UPDATE_REPORT_CONNECTIONS = 'server/update_report_connections';

export const SERVER_UPDATE_REPORT_USER_COMMENT = 'server/update_report_user_comment';
export const SERVER_DELETE_REPORT_USER_COMMENT = 'server/delete_report_user_comment';

export const SERVER_UPDATE_REPORT_RECORDS = 'server/update_report_records';
export const SERVER_GET_CONNECTED_REPORTS = 'server/get_connected_reports';
export const SERVER_GET_ADDITIONAL_REPORT_DATA = 'server/get_additional_report_data';

export const SERVER_SET_ANONYMIZE_STATE = 'server/set_anonymize_state';
export const UPDATE_REPORT_ANONYMIZE_STATE = 'update_report_anonymize_state';

// NewReport const

export const SET_NEW_REPORT_DRAWER_STATE = 'set_new_report_drawer_state';
export const SET_NEW_REPORT_PROP_VALUE = 'set_new_report_prop_value';
export const REMOVE_NEW_REPORT_IMAGE = 'remove_new_report_image';
export const SET_NEW_REPORT_ADDRESS_ATTRIBUTE = 'set_new_report_address_attribute';
export const SET_NEW_REPORT_LOCATION = 'set_new_report_location';
export const RESET_NEW_REPORT_FORM = 'reset_new_report_form';
export const SHOW_NEW_REPORT_GET_ADDRESS_ERROR = 'show_new_report_get_address_error';
export const SHOW_NEW_REPORT_FEEDBACK = 'show_new_report_feedback';

export const SERVER_SEND_NEW_REPORT = 'server/send_new_report';

// AccountSettings const

export const REQUEST_INITIAL_APP_SETUP = 'request_initial_app_setup';
export const INITIAL_APP_SETUP = 'initial_app_setup';
export const SET_ACCOUNT_SETTINGS_CHAT_TEMPLATES = 'set_account_settings_chat_templates';
export const SET_TYPES = 'set_types';
export const SET_AREA_TYPES = 'set_area_types';
export const SET_ORGANISATION_STRUCTURE = 'set_organisation_structure';
export const SET_CONTACTS = 'set_contacts';
export const SET_CHAT_TEMPLATES = 'set_chat_templates';

// AccountSettings const

export const SERVER_GET_INITITIAL_APP_SETUP = 'server/get_initial_app_setup';

// Header Notifications const

export const SET_USER_NOTIFICATIONS = 'set_user_notifications';

export const SERVER_MARK_NOTIFICATION_AS_SEEN = 'server/mark_notification_as_seen';

// Notifications const
// Report Details
export const COMPLETE_REPORT_SUCCESS = 'complete_report_success';
export const COMPLETE_REPORT_ERROR = 'complete_report_error';
export const DECLINE_REPORT_SUCCESS = 'decline_report_success';
export const DECLINE_REPORT_ERROR = 'decline_report_error';
export const DELETE_REPORT_SUCCESS = 'delete_report_success';
export const DELETE_REPORT_ERROR = 'delete_report_error';
export const RESTORE_REPORT_SUCCESS = 'restore_report_success';
export const RESTORE_REPORT_ERROR = 'restore_report_error';
export const EDIT_REPORT_SUCCESS = 'edit_report_success';
export const EDIT_REPORT_ERROR = 'edit_report_error';
export const CONNECT_REPORT_SUCCESS = 'connect_report_success';
export const CONNECT_REPORT_ERROR = 'connect_report_error';
export const SET_REPORT_DEADLINE_SUCCESS = 'set_report_deadline_success';
export const SET_REPORT_DEADLINE_ERROR = 'set_reprot_deadline_error';
export const SET_REPORT_RESUBMISSION_SUCCESS = 'set_report_resubmission_success';
export const SET_REPORT_RESUBMISSION_ERROR = 'remove_report_resubmission_error';
export const STOP_OBSERVING_REPORT_SUCCESS = 'stop_observing_report_success';
export const STOP_OBSERVING_REPORT_ERROR = 'stop_observing_report_error';
export const ASSIGN_REPORT_SUCCESS = 'assign_report_success';
export const ASSIGN_REPORT_ERROR = 'assign_report_error';
export const CREATE_NEW_REPORT_SUCCESS = 'create_new_report_success';
export const CREATE_NEW_REPORT_ERROR = 'create_new_report_error';
export const SET_REPORT_PRIORITY_SUCCESS = 'set_report_priority_success';
export const SET_REPORT_PRIORITY_ERROR = 'set_report_priority_error';

// Profile

export const SET_USER_GROUP_ROLE_SUCCESS = 'set_user_group_role_success';
export const SET_USER_GROUP_ROLE_ERROR = 'set_user_group_role_success';
export const UPDATE_USER_DATA_SUCCESS = 'update_user_data_success';
export const UPDATE_USER_DATA_ERROR = 'update_user_data_error';
export const UPDATE_USER_REPLACEMENTS_SUCCESS = 'update_user_replacements_success';
export const UPDATE_USER_REPLACEMENTS_ERROR = 'update_user_replacements_error';
export const UPDATE_USER_NOTIFICATION_SETTINGS_SUCCESS = 'update_user_notification_settings_success';
export const UPDATE_USER_NOTIFICATION_SETTINGS_ERROR = 'update_user_notification_settings_error';
export const UPDATE_USER_ASSIGNMENT_OPTIONS_SUCCESS = 'update_user_assignment_options_success';
export const UPDATE_USER_ASSIGNMENT_OPTIONS_ERROR = 'update_user_assignment_options_error';
export const UPDATE_ORGANISATION_RESPONSIBILITIES_SUCCESS = 'update_organisation_responsibilities_success';
export const UPDATE_ORGANISATION_RESPONSIBILITIES_ERROR = 'update_organisation_responsibilities_error';
export const UPDATE_ORGANISATION_MELDOO_APP_SETTINGS_SUCCESS = 'update_organisation_meldoo_app_settings_success';
export const UPDATE_ORGANISATION_MELDOO_APP_SETTINGS_ERROR = 'update_organisation_meldoo_app_settings_error';
export const UPDATE_ORGANISATION_MELDOO_WEB_SETTINGS_SUCCESS = 'update_organisation_meldoo_web_settings_success';
export const UPDATE_ORGANISATION_MELDOO_WEB_SETTINGS_ERROR = 'update_organisation_meldoo_web_settings_error';
export const ADD_ORGANISATION_APP_USER_CONNECTION_SUCCESS = 'add_organisation_app_user_connection_success';
export const ADD_ORGANISATION_APP_USER_CONNECTION_ERROR = 'add_organisation_app_user_connection_error';
export const REMOVE_ORGANISATION_APP_USER_CONNECTION_SUCCESS = 'remove_organisation_app_user_connection_success';
export const REMOVE_ORGANISATION_APP_USER_CONNECTION_ERROR = 'remove_organisation_app_user_connection_error';

export const SHOW_ADD_ASSIGNMENT_SUCCESS = 'show_add_assignment_success';
export const HIDE_ADD_ASSIGNMENT_SUCCESS = 'hide_add_assignment_success';
export const SHOW_ADD_ASSIGNMENT_ERROR = 'add_assignment_error';

export const UPDATE_ADMIN_SYSTEM_ROLE_DATA_SUCCESS = 'update_admin_system_role_data_success';
export const UPDATE_ADMIN_SYSTEM_ROLE_DATA_ERROR = 'update_admin_system_role_data_error';
export const ADD_ADMIN_SYSTEM_ROLE_ERROR = 'add_admin_system_role_error';
export const DELETE_ADMIN_SYSTEM_ROLE_SUCCESS = 'delete_admin_system_role_success';
export const DELETE_ADMIN_SYSTEM_ROLE_ERROR = 'delete_admin_system_role_error';

// GeneralSearch const

export const SERVER_GET_SEARCH_RESULTS = 'server/get_search_results';
export const SET_REPORT_SEARCH_RESULTS = 'set_report_search_results';
export const SET_CITIZEN_SEARCH_RESULTS = 'set_citizen_search_results';
export const SET_GENERAL_SEARCH_VALUE = 'set_general_search_value';

// Content const

export const SET_FAQ_CONTENT = 'set_faq_content';

export const SERVER_GET_FAQ_CONTENT = 'server/get_faq_content';

// Admin Responsibilities

export const SET_ADMIN_RESPONSIBILITIES = 'set_admin_responsibilities';
export const SET_RESPONSIBILITY_AREA_DATA = 'set_responsibility_area_data';
export const SET_UPDATED_RESPONSIBILITY_AREA_RESPONSIBLES = 'set_updated_responsibility_area_responsibles';
export const UPDATE_RESPONSIBILITY_AREA_DATA = 'update_responsibility_area_data';

export const SERVER_GET_ADMIN_RESPONSIBILITIES = 'server/get_admin_responsibilities';
export const SERVER_GET_RESPONSIBILITY_AREA_DATA = 'server/get_responsibility_area_data';
export const SERVER_GET_UPDATED_RESPONSIBILITY_AREA_RESPONSIBLES = 'server/get_updated_area_responsibles';
export const SERVER_UPDATE_RESPONSIBILITY_AREA_DATA = 'server/update_responsibility_area_data';

// Admin System Roles

export const SET_ADMIN_SYSTEM_ROLES = 'set_admin_system_roles';
export const SET_ADMIN_SYSTEM_ROLE_DATA = 'set_admin_system_role_data';
export const ADD_ADMIN_SYTEM_ROLE = 'add_admin_system_role';
export const SERVER_GET_ADMIN_SYSTEM_ROLES = 'server/get_admin_system_roles';
export const SERVER_GET_ADMIN_SYSTEM_ROLE_DATA = 'server/get_admin_system_role_data';
export const SERVER_UPDATE_ADMIN_SYSTEM_ROLE_DATA = 'server/update_admin_system_role_data';
export const SERVER_ADD_ADMIN_SYSTEM_ROLE = 'server/add_admin_system_role';
export const SERVER_DELETE_ADMIN_SYSTEM_ROLE = 'server/delete_admin_system_role';

export const SET_ORGANISATION_LIST = 'set_organisation_list';

export const SERVER_GET_ORGANISATION_LIST = 'server/get_organisation_list';

// MeldooWeb

export const SET_MELDOO_WEB_REPORTS = 'set_meldoo_web_reports';
export const APPEND_MELDOO_WEB_REPORTS = 'append_meldoo_web_reports';

export const SET_MELDOO_WEB_REPORT_DETAILS = 'set_meldoo_web_report_details';
export const SET_MELDOO_WEB_SEARCH_RESULTS = 'set_meldoo_web_search_results';
export const SET_MELDOO_WEB_SEARCH_RESULTS_DONE = 'set_meldoo_web_search_results_done';

export const CLEAR_MELDOO_WEB_SEARCH_RESULTS = 'clear_meldoo_web_search_results';
export const CLEAR_MELDOO_WEB_REPORTS = 'clear_meldoo_web_reports';

export const APPEND_MELDOO_WEB_SEARCH_RESULTS = 'append_meldoo_web_search_results';
export const SET_MELDOO_WEB_SETTINGS = 'set_meldoo_web_settings';
export const SET_MELDOO_WEB_CAPTCHA = 'set_meldoo_web_captcha';
export const SEND_NEW_MELDOO_WEB_REPORT_SUCCESS = 'send_new_meldoo_web_report_success';
export const SEND_NEW_MELDOO_WEB_REPORT_ERROR = 'send_new_meldoo_web_report_error';
export const RESET_SEND_NEW_MELDOO_WEB_REPORT_RESPONSE = 'reset_new_meldoo_web_report_response';

export const SERVER_GET_MELDOO_WEB_REPORTS = 'server/get_meldoo_web_reports';
export const SERVER_GET_MELDOO_WEB_REPORT_DETAILS = 'server/get_meldoo_web_report_details';
export const SERVER_GET_MELDOO_WEB_SEARCH_RESULTS = 'server/get_meldoo_web_search_results';
export const SERVER_GET_MELDOO_WEB_SETTINGS = 'server/get_meldoo_web_settings';
export const SERVER_GET_MELDOO_WEB_CAPTCHA = 'server/get_meldoo_web_captcha';
export const SERVER_SEND_NEW_MELDOO_WEB_REPORT = 'server/send_new_meldoo_web_report';
export const SERVER_GET_MELDOO_WEB_TYPES_BY_LOCATION = 'server/server_get_meldoo_web_types_by_location';
export const SET_MELDOO_WEB_TYPES_BY_LOCATION = 'set_meldoo_web_types_by_location';
export const SERVER_GET_MELDOO_WEB_TYPES_BY_ORGANISATIONKEY = 'server/server_get_meldoo_web_types_by_organisationkey';
export const SET_MELDOO_WEB_TYPES_BY_ORGANISATIONKEY = 'set_meldoo_web_types_by_organisationkey';

// Admin Feedback

export const SET_ADMIN_FEEDBACK = 'set_admin_feedback';
export const SERVER_GET_ADMIN_FEEDBACK_CHAT = 'server/get_admin_feedback_chat';
export const SET_ADMIN_FEEDBACK_CHAT = 'set_admin_feedback_chat';
export const SERVER_SEND_FEEDBACK_MESSAGE = 'server/send_feedback_message';

// News

export const SET_SYSTEM_NEWS = 'set_system_news';

export const SERVER_GET_SYSTEM_NEWS = 'server/get_system_news';

// Allgemein

export const START_INTRO_TOUR = 'start_intro_tour';
export const RESET_INTRO_TOUR = 'reset_intro_tour';

export const SERVER_RESET_SHOW_INFO_MODAL_FLAG = 'server/reset_show_info_modal_flag';
export const OPEN_INFO_MODAL = 'open_info_modal';

export const COMMON_UPDATE_SUCCESS = 'common_update_success';
export const COMMON_UPDATE_ERROR = 'common_update_error';

export const COMMON_ERROR = 'common_error';
export const COMMON_SUCCESS = 'common_success';

export const AUTH_ERROR = 'auth_error';

export const SERVER_SEND_MAIL_RESPONSE = 'server/send_mail_response';
export const SERVER_GET_MAIL_RESPONSE_DATA = 'server/get_response_mail_data';
export const SEND_MAIL_RESPONSE_SUCCESS = 'send_mail_response_success';
export const SEND_MAIL_RESPONSE_ERROR = 'send_mail_response_error';
export const SET_MAIL_RESPONSE_DATA = 'set_mail_response_data';
export const GET_MAIL_RESPONSE_DATA_ERROR = 'get_mail_response_data_error';
export const RESET_MAIL_RESPONSE_MODALS = 'reset_mail_response_modals';
export const ADD_MAIL_RESPONSE_MESSAGE = 'add_mail_response_message';

// ---------------------------------------------------------------------------
// ---------------------------------------------------------------------------
// ----------------- Nur für Beschwerdemanagement RD ECK ---------------------
// ---------------------------------------------------------------------------
// ---------------------------------------------------------------------------

export const SET_NEW_ISSUE_DRAWER_STATE = 'set_new_issue_drawer_state';
export const SET_NEW_ISSUE_PROP_VALUE = 'set_new_issue_prop_value';
export const RESET_NEW_ISSUE_FORM = 'reset_new_issue_form';
export const SERVER_SEND_NEW_ISSUE = 'server/send_new_issue';
export const SHOW_NEW_ISSUE_FEEDBACK = 'show_new_issue_feedback';
export const CREATE_NEW_ISSUE_SUCCESS = 'create_new_issue_success';
export const CREATE_NEW_ISSUE_ERROR = 'create_new_issue_error';

// ----------------- Nur für Beschwerdemanagement RD ECK ---------------------



// WEBPACK FOOTER //
// ./constants/ActionTypes.js